import explorer from "../assets/images/product-images/Explorer.jpg";
import explorerPlus from "../assets/images/product-images/Explorer_Plus.jpg";
import qantas from "../assets/images/product-images/Business_Explorer.jpg";
import secondary from "../assets/images/product-images/Supplementary.jpg";
import traveller from "../assets/images/product-images/Traveller.jpg";
import discovery from "../assets/images/product-images/Discovery.jpg";
export { default as defaultImg } from "../assets/images/product-images/default.png";

export const membershipImages = [
  { key: "4288", membershipImg: traveller },
  { key: "4290", membershipImg: secondary },
  { key: "4291", membershipImg: explorer },
  { key: "4293", membershipImg: explorerPlus },
  { key: "4296", membershipImg: discovery },
  { key: "4304", membershipImg: explorer },
  { key: "4306", membershipImg: traveller },
  { key: "4299", membershipImg: explorer },
  { key: "4297", membershipImg: traveller },
  qantas,
];